import React, { useState, useEffect, useRef } from 'react';
import '../App.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, FormGroup, Button, Label, Input } from 'reactstrap';
import MyStorage from './util/storage'
import { Oval as Loader } from 'react-loader-spinner'
import moment from 'moment';
import { ToastContainer } from 'react-toastify';
import showToast from './util/toast'
import db, { storage } from '../../firebase/firebase';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import add from '../assets/add.png';
import cross from '../assets/delete.png';

let i = 1
let imageUrls = []

const AdminContact = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [timing, setTiming] = useState('');
    const [ticker, setTicker] = useState('');

    const [loader, setLoader] = useState(false);

    useEffect(() => {
        loadInfo()
    }, [])

    if (!MyStorage.isLogin()) {
        console.log('not logged in');
        navigate('/admin/login', { replace: true })
        return null
    }

    const loadInfo = async () => {
        let doc = await db.collection('contact-info')
            .doc('contact-info')
            .get()
        let data = doc.data()
        setPhone(data.phone ? data.phone : '')
        setEmail(data.email ? data.email : '')
        setAddress(data.address ? data.address : '')
        setTiming(data.timing ? data.timing : '')
        setTicker(data.ticker ? data.ticker : '')
    }

    const saveContactInfo = () => {
        setLoader(true);
        // update info
        db.collection('contact-info')
            .doc('contact-info')
            .set({
                phone: phone,
                email: email,
                address: address,
                timing: timing,
                ticker: ticker,
            }, { merge: true })
            .then(() => {
                setLoader(false);
                showToast('success', 'Changes Saved!')
            })
            .catch(error => {
                showToast('error', 'Save Failed!');
            });
    }

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Contact Info
                </div>
            </div>

            <div
                style={{ width: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
                <div style={{ paddingTop: 30, paddingBottom: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', overflow: 'scroll' }}>
                    <Form className='form' style={{ padding: 0, backgroundColor: '#f2f2f2', borderRadius: 10, minWidth: 600 }}>

                        <div style={{ marginBottom: 10, display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center' }}>

                            
                            <FormGroup style={{ marginTop: 0, width: '100%' }}>
                                <div style={{color:'gray'}}>Phone</div>
                                <Input
                                    style={{ fontSize: 18 }}
                                    type='text'
                                    placeholder='Enter Phone'
                                    value={phone}
                                    onChange={(event) => {
                                        console.log('change: ' + event.target.value);
                                        setPhone(event.target.value)
                                    }} />
                            </FormGroup>

                            <FormGroup style={{ marginTop: 0, width: '100%' }}>
                                <div style={{color:'gray'}}>Email</div>
                                <Input
                                    style={{ fontSize: 18 }}
                                    type='text'
                                    placeholder='Enter Email'
                                    value={email}
                                    onChange={(event) => {
                                        setEmail(event.target.value)
                                    }} />
                            </FormGroup>

                            <FormGroup style={{ marginTop: 0, width: '100%' }}>
                                <div style={{color:'gray'}}>Address</div>
                                <Input
                                    style={{ fontSize: 18 }}
                                    type='text'
                                    placeholder='Enter Address'
                                    value={address}
                                    onChange={(event) => {
                                        setAddress(event.target.value)
                                    }} />
                            </FormGroup>

                            <FormGroup style={{ marginTop: 0, width: '100%' }}>
                                <div style={{color:'gray'}}>Open Hours</div>
                                <Input
                                    style={{ fontSize: 18 }}
                                    type='text'
                                    placeholder='Enter Open Timing'
                                    value={timing}
                                    onChange={(event) => {
                                        setTiming(event.target.value)
                                    }} />
                            </FormGroup>

                            <FormGroup style={{ marginTop: 0, width: '100%' }}>
                                <div style={{color:'gray'}}>Ticker</div>
                                <Input
                                    style={{ fontSize: 18 }}
                                    type='textarea'
                                    placeholder='Enter Ticker'
                                    value={ticker}
                                    onChange={(event) => {
                                        setTicker(event.target.value)
                                    }} />
                            </FormGroup>

                        </div>

                        <Button
                            className='btn-block btn-dark'
                            style={{ marginTop: 15, fontSize: 18, fontWeight: 'bold', width: '100%', backgroundColor: 'orange', borderWidth: 0, height: 50 }}
                            onClick={() => {
                                saveContactInfo()
                            }}>
                            Save Changes
                        </Button>

                    </Form>
                </div>
            </div>

            {loader ?
                <div style={{ position: 'absolute', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '80%', width: '80%' }}>
                    <div style={{ padding: 10, backgroundColor: 'red', borderRadius: 100 }}>
                        <Loader
                            type="ThreeDots"
                            color="white"
                            height={70}
                            width={70}
                            visible={true} />
                    </div>
                </div>
                :
                null
            }

            <div>
                <ToastContainer />
            </div>

        </div>
    );
}

export default AdminContact;